import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
// Assets
import images from '../../../assets/images/images';
// Components
import { Button, Image, CustomLink, Input } from '../..';
// Styles
import styles from './contactPointSelector.module.scss';

interface IContactPointSelectorProps {
    recipientList: {
        name: string;
        fullName: string;
        contactPointId?: string;
    }[];
    onSelectContactPoint: (event?: React.MouseEvent) => void;
    onRemoveContactPoint: (contactPointIndex: number) => void;
    allowMultiple: boolean;
    isFromForward?: boolean;
}

export const ContactPointSelector = (props: IContactPointSelectorProps): JSX.Element => {
    const { formatMessage } = useIntl();

    const generateRecipientRow = ({
        fullName,
        contactPointId,
    }: {
        fullName: string;
        contactPointId?: string;
    }): JSX.Element => (
        <div className="text-truncate">
            <span title={fullName}>{fullName}</span>
        </div>
    );

    const showSelectInput = !(!props.allowMultiple && props.recipientList.length === 1);
    const recipientRowList = props.recipientList.map((contactPoint, index) => (
        <div key={'contactPointDiv' + index} className="row align-items-center p-0 m-2">
            <div className={`w-100 d-flex justify-content-between pb-2 ${showSelectInput ? 'border-bottom' : ''}`}>
                {contactPoint?.fullName !== null ? (
                    <div className="text-truncate col-sm-11 pl-0">{generateRecipientRow(contactPoint)}</div>
                ) : (
                    <div className="text-truncate">
                        <span title={contactPoint?.name}>{contactPoint?.name}</span>
                    </div>
                )}
                <CustomLink
                    onClick={(): void => {
                        props.onRemoveContactPoint(index);
                    }}
                    title={formatMessage({ id: 'DELETE' })}
                >
                    <Image src={images.close} alt="DELETE" />
                </CustomLink>
            </div>
        </div>
    ));

    return (
        <div className={styles.contactPointsWrapper}>
            {recipientRowList}

            {showSelectInput && (
                <div
                    className={`w-100 d-flex justify-content-between ${
                        props.recipientList.length > 0 ? 'pb-2 pr-2' : ''
                    }`}
                    style={{ cursor: 'text' }}
                    onClick={props.onSelectContactPoint}
                >
                    <Input
                        className={`${styles.dummyInput} pl-2`}
                        disabled
                        name="chooseRecipientInput"
                        placeholder="TO_RECIPIENT"
                        ariaLabel="TO_RECIPIENT"
                        value=""
                    />

                    <Button
                        className="m-0"
                        type="button"
                        ariaLabel={formatMessage({ id: 'CHOOSE_RECIPIENT' })}
                        onClick={props.onSelectContactPoint}
                    >
                        <FormattedMessage id="SELECT" />
                    </Button>
                </div>
            )}
        </div>
    );
};
